import { apiClient } from '@api/apiClient';
import { ToastType } from '@components';
import { unwrapResult } from '@store/creditApplications/policies';
import { createError } from '@utils/errorUtils';
import { handleToast } from '@utils/utils';

import type { EscalationCaseDto } from './types';

type ApiResult<T> = {
  value?: T;
};

const ESCALATION_POLICY_BASE = '/policies/ai-safety';

export async function fetchOpenEscalations(): Promise<EscalationCaseDto[]> {
  try {
    const response = await apiClient.get<
      EscalationCaseDto[] | ApiResult<EscalationCaseDto[]>
    >(`${ESCALATION_POLICY_BASE}/escalations`, {
      params: { status: 'Open' },
    });
    return unwrapResult<EscalationCaseDto[]>(response);
  } catch (e: unknown) {
    const error = createError(e, 'Failed to get escalations');
    handleToast(ToastType.Error, error.message);
    return [];
  }
}

export async function resolveOpenEscalation(id: number): Promise<boolean> {
  try {
    const response = await apiClient.post<unknown | ApiResult<unknown>>(
      `${ESCALATION_POLICY_BASE}/escalations/${id}/resolve`,
    );
    unwrapResult<unknown>(response);
    return true;
  } catch (e: unknown) {
    const error = createError(e, 'Failed to resolve escalation');
    handleToast(ToastType.Error, error.message);
    return false;
  }
}
